import axios from "axios";
import { BASE_URL } from "../config";

axios.defaults.withCredentials = true;

export const createUserRequest = async (user) => {
  return await axios.post(`${BASE_URL}/api/user-signup`, user);
};

export const loginRequest = async (user) => {
  return await axios.post(`${BASE_URL}/api/users-login`, user);
};

export const logoutRequest = async () => {
  return await axios.post(`${BASE_URL}/api/user/logout`);
};

//Este es el header que deben tener las peticiones que vayan protegidas
export const IsLogged = async () => {
  return await axios.get(`${BASE_URL}/api/user/verifyuser`);
};

//para resetear la contraseña
export const reqResetEmail = async (email) => {
  return await axios.post(`${BASE_URL}/api/user/forgot-password`, { email });
};

export const changePass = async (token, newPassword) => {
  return await axios.post(`${BASE_URL}/api/user/reset-password`, {
    token,
    newPassword,
  });
};
